import { useUser } from "@/providers/context";
import { useMutation, useQueryClient } from "react-query";
import { AxiosError } from "axios";
import { deleteEvent, DeleteEvent } from "@/api";

export const useDeleteEvent = () => {
  const { uid } = useUser();
  const queryClient = useQueryClient();

  return useMutation<unknown, AxiosError<{ detail: string }>, DeleteEvent>(
    (variables) => {
      if (!uid) {
        return Promise.reject();
      }
      return deleteEvent({ ...variables, UserId: uid });
    },
    {
      onSuccess: async (data) => {
        queryClient.setQueryData(["userEvent", uid], data);
      },
    },
  );
};
